module.exports = __webpack_public_path__ + "img/17.5c8d42f1.jpg";